export { default as EpTermsPage } from "./View";